<template>
  <div class="scoped-container">
    <div v-if="kpi" class="scoped-item cx-focus-kpi-item">
      <CxGoogleIcon v-if="kpi.name === 'google'" class="scoped-small" />
      <CxVisualPresentationIcon v-else-if="kpi.name === 'ncuc_visualpresentation'" />
      <CxActionManagementIcon v-else-if="kpi.name === 'firstaidkits'" />
      <CxSeobilityIcon v-else-if="kpi.name === 'average_seobility'" />
      <CxReactionTimeIcon v-else-if="kpi.name === 'average_responsetime'" />
      <div v-else />

      <!-- {{ $t('Webportal.CX.Dashboard.Topbar.' + kpi.name) }} -->
      <h5 v-if="kpi.onlyLogo === 0" class="center-text" >{{ getTitle }}</h5>
      <div v-else class="center-text" >&nbsp;</div>
      
      <div class="cx-icon-container">
        <b-icon class="cx-dialog-icon cx-clickable-icon"
                icon="question-circle" 
                scale="1.0"
                @click="toggleHelpPopup()" />
      </div>
    </div>
    
    <div v-if="kpi" class="scoped-overlay scoped-lg">
      <div :class="{ 'scoped-action': 1 }">
        <div class="scoped-action-overlay" :style="{ 'color': getColorByValue }">
          {{ getValue(kpi.value) }} 
          <b-icon v-if="kpi.type === 'star'" 
                  icon="star-fill" 
                  :style="{ 'color': getColorByValue }"></b-icon>
        </div>

        <div v-if="isActionManagementItem" class="scoped-action-overlay">
          <b-button v-if="kpi.name === 'firstaidkits'"
                    @click="toggleModal()"
                    size="sm" 
                    :variant="getTheme">
            Start Action
          </b-button>
        </div>

        <div v-if="kpi.name === 'firstaidkits'" class="scoped-action-overlay scoped-sm">
          Available Actions: {{ getAvailableActions() }} 
        </div>
      </div>
    </div>
    
    <div v-else class="centered-indicator">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>

    <div v-if="kpi" class="scoped-item scoped-bottom" :style="{ 'color': threshold[2].Color }">
      <b-icon icon="bullseye"></b-icon>
      {{ $t('Webportal.CX.Dashboard.ActionManagementCenter.Target') }} {{ getTargetValue(kpi.threshold) }}
    </div>
    
    <GenericHelpPopup v-if="showHelpPopup"
                      @close="showHelpPopup=false"
                      :title="$t(`Webportal.CX.Dashboard.Topbar.${kpi.name.replace(/\s/g,'')}`)">
      <div v-html="$t(`Webportal.CX.Dashboard.Topbar.${kpi.name.replace(/\s/g,'')}.Text`)"></div>
    </GenericHelpPopup>

    <b-modal  v-if="isActionManagementItem" 
              ref="my-modal"
              size="xl"
              id="my-modal"
              :title="this.$t('Webportal.CX.Dashboard.ActionManagement')">
      <ActionManagementCenter v-show="showActionManagementCenter"
                              :explorationData="actionManagementCenter_ExpData"
                              :explorationAugmentionData="actionManagementCenter_ExpAugData"
                              :isLegacyMode="false"
                              :clientLocationId="dashboardData.ClientLocationId"
                              :resolvedApiIds="dashboardData.Exploration.ResolvedApis"
                              :resolvedExtSurveyIds="getResolvedApisFromSurveys()"
                              :threshold="threshold"
                              @close="showActionManagementCenter = false"
                              @resolved="resolvedFirstAidKit" />
     </b-modal> 

  </div>
</template>

<script>
import ActionManagementCenter from '@/components/CX/ActionManagementCenter.vue';
import CxGoogleIcon from './FocusKpi/CxGoogleIcon.vue';
import CxVisualPresentationIcon from './FocusKpi/CxVisualPresentationIcon.vue';
import CxActionManagementIcon from './FocusKpi/CxActionManagementIcon.vue';
import CxSeobilityIcon from './FocusKpi/CxSeobilityIcon.vue';
import CxReactionTimeIcon from './FocusKpi/CxReactionTimeIcon.vue';
import { formatHoursMinutes } from '@/components/CX/Grid/dateTime';
import GenericHelpPopup from "@/components/Shared/GenericHelpPopup";
import CxActionManagementMixin from '@/mixins/CxActionManagementMixin';

export default {
  components: {
    ActionManagementCenter, CxGoogleIcon, CxVisualPresentationIcon, CxActionManagementIcon,
    CxSeobilityIcon, CxReactionTimeIcon, GenericHelpPopup
  },

  mixins: [ CxActionManagementMixin ],

  data: function() {
    return {
      showActionManagementCenter: false,
      showHelpPopup: false,
      // TODO: Was macht das?
    }
  },

  props: {
    // dashboardData:    { type: Object, default: () => undefined },
    kpi:              { type: Object, default: () => undefined },
    reference:        { type: String, required: true },
    theme:            { type: String, default: () => 'light' },
    // threshold:        { type: Array, required: true }
  },
  
  computed: {
    getTitle() {
      switch (this.kpi?.name) {
        case 'ncuc_visualpresentation':
          return 'Visual Presentation';
        case 'firstaidkits':
          return 'Measures';
        case 'average_responsetime':
          return 'TBD';
        default:
          return '';
      }
    },

    getColorByValue() {
      return this.threshold[this.getColorIndex()].Color;
    },

    getTheme() {
      return this.theme === 'dark' ? 'outline-light' : 'outline-dark';
    },

    isActionManagementItem() {
      return !this.kpi.disableActions && this.kpi.name === 'firstaidkits';
    },
  },

  methods: {
    getColorIndex() {
       switch (this.kpi.type) {
        case 'star':
        case 'percentage':
          return this.kpi.threshold <= this.kpi.value ? 2 : 0;

        case 'time':
          return this.kpi.threshold >= this.kpi.value ? 2 : 0;
        
        default:
         if (this.isActionManagementItem) {
            return this.resolved >= this.maxResolvable ? 2 : 0;
          } else {
            return this.kpi.Accomplished >= this.kpi.Total ? 2 : 0;
          }
      }
    },

    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.toggleHelpPopup(true);
      }
    },

    toggleHelpPopup(forceClose) {
      if (forceClose) {
        window.removeEventListener('keyup', this.handleKeyUp);
        this.showHelpPopup = false;
      } else {
        if (!this.showHelpPopup) {
          this.$emit('focuskpigrid-close-help-popups', this.reference);
          window.addEventListener('keyup', this.handleKeyUp);
        } else {
          window.removeEventListener('keyup', this.handleKeyUp);
        }
        this.showHelpPopup = !this.showHelpPopup;
      }
    },

    toggleModal(event) {
      console.log(event)
      this.$refs['my-modal'].show();
      this.showActionManagementCenter = true;
    },

    getValue(value) {
      switch (this.kpi.type) {
        case 'star':
          if (value === undefined ||Number.isNaN(value))
            return 'N/A';
          return value;

        case 'percentage':
          if (value === undefined ||Number.isNaN(value))
            return 'N/A';
          return `${value}%`;

        case 'time':
          if (value === undefined ||Number.isNaN(value))
            return 'N/A';
          return `${formatHoursMinutes(value, false)}h`;

        default:
          if (this.isActionManagementItem) {
            if (this.maxResolvable === undefined || this.maxResolvable === 0) {
              return 'N/A';
            }
            return this.resolved + " / " + this.maxResolvable;
          } else {
            if (this.kpi.Total === undefined || this.kpi.Total === 0) {
              return 'N/A';
            }
            return this.kpi.Accomplished + " / " + this.kpi.Total;
          }
      }
    },
    
    getAvailableActions() {
      if (this.isActionManagementItem) {
        if (this.maxResolvable === undefined || this.maxResolvable === 0) {
          return 'N/A';
        }
        return this.maxResolvable - this.resolved;
      } else {
        if (this.kpi.Total === undefined || this.kpi.Total === 0) {
          return 'N/A';
        }
        return this.kpi.Total - this.kpi.Accomplished;
      }
    },

    getTargetValue(value) {
      switch (this.kpi.type) {
        case 'star':
        case 'percentage':
        case 'time':
          return this.getValue(value);
        default:
          if (this.isActionManagementItem) {
            return this.maxResolvable;
          } else {
            return this.kpi.Total;
          }
      }
    },
  }
}
</script>

<style scoped>
.cx-icon-container {
  align-self: self-start;
  right: 12px;
  position: absolute;
}
.centered-indicator {
  display: flex;
  justify-content: center; /* centers horizontally */
  /* margin-top: 1.25rem; */
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 32px;
    left: 32px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 32px;
    left: 32px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 32px;
    left: 32px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 64px;
    height: 64px;
    opacity: 0;
  }
}

.scoped-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  /* min-height: 10rem; */
}

.cx-focus-kpi-item {
  display: grid;
  grid-template-columns: 1fr 6fr 1fr;
  column-gap: 0.25rem;
  padding: 0.5rem 0.5rem 0rem 0.5rem;
}

.scoped-lg {
  font-size: 18pt;
  font-weight: 600;
}

.scoped-sm {
  font-size: 10pt;
  font-weight: 500;
}

.scoped-bottom {
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
}

.center-text {
  text-align: center;
}

.scoped-overlay {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.scoped-action {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.scoped-action-overlay {
  text-align: center;
  line-height: 1.2;
}

</style>